import { getValidation } from 'commonsUtilities/validations';
import DOCUMENT_CODES from 'commons-components/src/constants/documentCodes';

const { DOCUMENT_PA, DOCUMENT_PN, DOCUMENT_PP, DOCUMENT_PASSPORT } = DOCUMENT_CODES;

const passportDocumentCodesByCountry = {
    PT: DOCUMENT_PP,
    NL: DOCUMENT_PN,
    ES: DOCUMENT_PASSPORT,
    DE: DOCUMENT_PA,
    default: DOCUMENT_PASSPORT,
};

const getPassportDocumentCode = nationality =>
    Object.keys(passportDocumentCodesByCountry).includes(nationality)
        ? passportDocumentCodesByCountry[nationality]
        : passportDocumentCodesByCountry.default;

export const getPassportValidations = (isRequired, nationality) => ({
    ...(isRequired && { required: value => value && value.length }),

    valid: value => getValidation(value, getPassportDocumentCode(nationality)).valid,
});
